import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from 'auth/AuthContext'
import ProtectedRoute from 'auth/ProtectedRoute'

import Login from 'auth/Login'
import SignUpCard from 'components/SignUpCard'

import MainLayout from 'components/Layout'
import DashboardLayout from 'components/Dashboard/Layout'
import ManagementLayout from 'components/Management/Layout'

import Reports from 'components/Reports'
import Help from 'components/Help'

import DataEditLayout from 'components/Management/DataEditLayout'
import AgroDataEdit from 'components/Management/AgroDataEdit'
import PickingDataEdit from 'components/Management/PickingDataEdit'
import PackingDataEdit from 'components/Management/PackingDataEdit'
import TimingDataEdit from 'components/Management/TimingDataEdit'

import { PERMISSIONS } from 'constants/permissions'
import componentMap from 'routes/componentMap'
import { MANAGEMENT_TABS, DASHBOARD_TABS } from 'constants/navs'

const withPermission = (permission, Component) => (
  <ProtectedRoute requiredPermission={permission}>
    <Component />
  </ProtectedRoute>
)

const AppRoutes = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public */}
          <Route path='/login' element={<Login />} />
          <Route path='/signup' element={<SignUpCard />} />
          <Route path='/' element={<Navigate to='/login' replace />} />

          {/* Protected */}
          <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
            <Route path='/dashboard' element={<DashboardLayout />}>
              <Route
                index
                element={withPermission(PERMISSIONS.LAST_WORKING_DAY_SUMMARY, componentMap['last-working-day-summary'])}
              />
              {DASHBOARD_TABS.map(({ to, permission }) => (
                <Route
                  key={to}
                  path={to}
                  element={withPermission(permission, componentMap[to])}
                />
              ))}
            </Route>

            <Route path='/management' element={<ManagementLayout />}>
              <Route
                index
                element={withPermission(PERMISSIONS.GENERAL_SETTINGS, componentMap.settings)}
              />
              {MANAGEMENT_TABS.map(({ to, permission }) => {
                if (to === 'data-edit') {
                  return (
                    <Route key={to} path={to} element={withPermission(permission, DataEditLayout)}>
                      <Route index element={<Navigate to='agro' />} />
                      <Route path='agro' element={<AgroDataEdit />} />
                      <Route path='picking' element={<PickingDataEdit />} />
                      <Route path='packing' element={<PackingDataEdit />} />
                      <Route path='timing' element={<TimingDataEdit />} />
                    </Route>
                  )
                }

                return (
                  <Route
                    key={to}
                    path={to}
                    element={withPermission(permission, componentMap[to])}
                  />
                )
              })}
            </Route>

            <Route path='/reports' element={<Reports />} />
            <Route path='/help' element={<Help />} />
          </Route>

        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default AppRoutes
